import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { rememberIntent, loginPathFor } from './postLoginRedirect';

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    // Render a loading indicator while checking auth status
    return <div>Loading...</div>;
  }

  if (!user) {
    // Park where the visitor was heading -- a QR code straight to /studies, say
    // -- so they land there once they are through the sign-in flow instead of
    // on the front page. See postLoginRedirect.js.
    rememberIntent(`${location.pathname}${location.search || ''}`);
    return <Navigate to={loginPathFor(location)} replace />;
  }
  const role = String(user.system_role || '').toLowerCase();
  if (requireAdmin && role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  return children;
}
